require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.sort.js");
/*! For license information please see contentstack.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Contentstack = e() : t.Contentstack = e();
}(self, () => (() => {
  "use strict";

  var t = {
      42: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0;
        var n = function (t, e) {
          if (t && t.__esModule) return t;
          if (null === t || "object" != i(t) && "function" != typeof t) return {
            default: t
          };
          var r = o(e);
          if (r && r.has(t)) return r.get(t);
          var n = {
              __proto__: null
            },
            a = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s in t) if ("default" !== s && {}.hasOwnProperty.call(t, s)) {
            var c = a ? Object.getOwnPropertyDescriptor(t, s) : null;
            c && (c.get || c.set) ? Object.defineProperty(n, s, c) : n[s] = t[s];
          }
          return n.default = t, r && r.set(t, n), n;
        }(r(925));
        function o(t) {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap(),
            r = new WeakMap();
          return (o = function (t) {
            return t ? r : e;
          })(t);
        }
        function i(t) {
          return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, i(t);
        }
        function a(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, s(n.key), n);
          }
        }
        function s(t) {
          var e = function (t) {
            if ("object" != i(t) || !t) return t;
            var e = t[Symbol.toPrimitive];
            if (void 0 !== e) {
              var r = e.call(t, "string");
              if ("object" != i(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(t);
          }(t);
          return "symbol" == i(e) ? e : e + "";
        }
        e.default = function () {
          return t = function t() {
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this._query = {}, this.only = n.transform("only"), this.except = n.transform("except"), this;
          }, e = [{
            key: "setCacheProvider",
            value: function (t) {
              return t && "object" === i(t) && (this.provider = t), this;
            }
          }, {
            key: "setCachePolicy",
            value: function (t) {
              return "number" == typeof t && t >= -1 && t < 4 ? this._query ? this.queryCachePolicy = t : this.cachePolicy = t : this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide the valid policy"), this;
            }
          }, {
            key: "includeReference",
            value: function () {
              for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
              if (Array.isArray(e) || "string" == typeof e) {
                if (arguments.length) for (var n = 0; n < arguments.length; n++) this._query.include = this._query.include || [], this._query.include = this._query.include.concat(arguments[n]);
                return this;
              }
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Argument should be a String or an Array.");
            }
          }, {
            key: "language",
            value: function (t) {
              if (t && "string" == typeof t) return this._query.locale = t, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Argument should be a String.");
            }
          }, {
            key: "addQuery",
            value: function (t, e) {
              if (t && e && "string" == typeof t) return this._query[t] = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "First argument should be a String.");
            }
          }, {
            key: "includeEmbeddedItems",
            value: function () {
              return this._query.include_embedded_items = ["BASE"], this;
            }
          }, {
            key: "includeSchema",
            value: function () {
              return this._query.include_schema = !0, this;
            }
          }, {
            key: "includeReferenceContentTypeUID",
            value: function () {
              return this._query.include_reference_content_type_uid = !0, this;
            }
          }, {
            key: "includeFallback",
            value: function () {
              return this._query.include_fallback = !0, this;
            }
          }, {
            key: "includeBranch",
            value: function () {
              return this._query.include_branch = !0, this;
            }
          }, {
            key: "includeMetadata",
            value: function () {
              return this._query.include_metadata = !0, this;
            }
          }, {
            key: "includeContentType",
            value: function () {
              return this._query.include_content_type = !0, this;
            }
          }, {
            key: "includeOwner",
            value: function () {
              return console.warn("The includeOwner function is deprecated."), this._query.include_owner = !0, this;
            }
          }, {
            key: "toJSON",
            value: function () {
              return this.tojson = !0, this;
            }
          }, {
            key: "addParam",
            value: function (t, e) {
              if (t && e && "string" == typeof t && "string" == typeof e) return this._query[t] = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            }
          }, {
            key: "variants",
            value: function (t) {
              return Array.isArray(t) && t.length > 0 ? this.headers["x-cs-variant-uid"] = t.join(",") : this.headers["x-cs-variant-uid"] = t, this;
            }
          }, {
            key: "fetch",
            value: function (t) {
              var e = this.config.host + ":" + this.config.port;
              if (this.live_preview && !0 === this.live_preview.enable && this.live_preview.live_preview && "init" !== this.live_preview.live_preview && (e = this.live_preview.host), this.entry_uid) {
                this.requestParams = {
                  method: "POST",
                  headers: n.mergeDeep({}, this.headers),
                  url: this.config.protocol + "://" + e + "/" + this.config.version + this.config.urls.content_types + this.content_type_uid + this.config.urls.entries + this.entry_uid,
                  body: {
                    _method: "GET",
                    query: this._query
                  }
                };
                var r = n.mergeDeep(this.fetchOptions, t);
                return n.sendRequest(n.mergeDeep({}, this), r);
              }
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide an entry uid. e.g. .Entry('asset_uid')");
            }
          }], e && a(t.prototype, e), Object.defineProperty(t, "prototype", {
            writable: !1
          }), t;
          var t, e;
        }();
      },
      54: (t, e, r) => {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0, ((n = r(154)) && n.__esModule ? n : {
          default: n
        }).default.polyfill(), e.default = fetch;
      },
      94: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.get = function (t) {
          var e = o.default.getItem(t);
          try {
            e = JSON.parse(e);
          } catch (t) {
            return e;
          }
          return e || null;
        }, e.getKeys = function () {
          return o.default ? Object.keys(o.default) : [];
        }, e.getStorage = function () {
          return o.default || null;
        }, e.set = function (t, e) {
          try {
            "object" === i(e) ? o.default.setItem(t, JSON.stringify(e)) : o.default.setItem(t, e);
          } catch (t) {}
        };
        var n,
          o = (n = r(514)) && n.__esModule ? n : {
            default: n
          };
        function i(t) {
          return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, i(t);
        }
      },
      154: (t, e, r) => {
        var n,
          o,
          i,
          a = r(444);
        function s(t) {
          return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, s(t);
        }
        i = function () {
          function t(t) {
            return "function" == typeof t;
          }
          var e = Array.isArray ? Array.isArray : function (t) {
              return "[object Array]" === Object.prototype.toString.call(t);
            },
            r = 0,
            n = void 0,
            o = void 0,
            i = function (t, e) {
              d[r] = t, d[r + 1] = e, 2 === (r += 2) && (o ? o(h) : g());
            },
            c = "undefined" != typeof window ? window : void 0,
            u = c || {},
            l = u.MutationObserver || u.WebKitMutationObserver,
            f = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
            y = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
          function p() {
            var t = setTimeout;
            return function () {
              return t(h, 1);
            };
          }
          var d = new Array(1e3);
          function h() {
            for (var t = 0; t < r; t += 2) (0, d[t])(d[t + 1]), d[t] = void 0, d[t + 1] = void 0;
            r = 0;
          }
          var v,
            _,
            m,
            b,
            g = void 0;
          function O(t, e) {
            var r = this,
              n = new this.constructor(j);
            void 0 === n[P] && N(n);
            var o = r._state;
            if (o) {
              var a = arguments[o - 1];
              i(function () {
                return x(o, n, a, r._result);
              });
            } else L(r, n, t, e);
            return n;
          }
          function w(t) {
            if (t && "object" === s(t) && t.constructor === this) return t;
            var e = new this(j);
            return A(e, t), e;
          }
          f ? g = function () {
            return process.nextTick(h);
          } : l ? (_ = 0, m = new l(h), b = document.createTextNode(""), m.observe(b, {
            characterData: !0
          }), g = function () {
            b.data = _ = ++_ % 2;
          }) : y ? ((v = new MessageChannel()).port1.onmessage = h, g = function () {
            return v.port2.postMessage(0);
          }) : g = void 0 === c ? function () {
            try {
              var t = Function("return this")().require("vertx");
              return void 0 !== (n = t.runOnLoop || t.runOnContext) ? function () {
                n(h);
              } : p();
            } catch (t) {
              return p();
            }
          }() : p();
          var P = Math.random().toString(36).substring(2);
          function j() {}
          var q = void 0,
            E = 1,
            k = 2;
          function S(e, r, n) {
            r.constructor === e.constructor && n === O && r.constructor.resolve === w ? function (t, e) {
              e._state === E ? D(t, e._result) : e._state === k ? C(t, e._result) : L(e, void 0, function (e) {
                return A(t, e);
              }, function (e) {
                return C(t, e);
              });
            }(e, r) : void 0 === n ? D(e, r) : t(n) ? function (t, e, r) {
              i(function (t) {
                var n = !1,
                  o = function (r, o) {
                    try {
                      r.call(o, function (r) {
                        n || (n = !0, e !== r ? A(t, r) : D(t, r));
                      }, function (e) {
                        n || (n = !0, C(t, e));
                      });
                    } catch (t) {
                      return t;
                    }
                  }(r, e, 0, 0, t._label);
                !n && o && (n = !0, C(t, o));
              }, t);
            }(e, r, n) : D(e, r);
          }
          function A(t, e) {
            if (t === e) C(t, new TypeError("You cannot resolve a promise with itself"));else if (o = s(n = e), null === n || "object" !== o && "function" !== o) D(t, e);else {
              var r = void 0;
              try {
                r = e.then;
              } catch (e) {
                return void C(t, e);
              }
              S(t, e, r);
            }
            var n, o;
          }
          function T(t) {
            t._onerror && t._onerror(t._result), R(t);
          }
          function D(t, e) {
            t._state === q && (t._result = e, t._state = E, 0 !== t._subscribers.length && i(R, t));
          }
          function C(t, e) {
            t._state === q && (t._state = k, t._result = e, i(T, t));
          }
          function L(t, e, r, n) {
            var o = t._subscribers,
              a = o.length;
            t._onerror = null, o[a] = e, o[a + E] = r, o[a + k] = n, 0 === a && t._state && i(R, t);
          }
          function R(t) {
            var e = t._subscribers,
              r = t._state;
            if (0 !== e.length) {
              for (var n = void 0, o = void 0, i = t._result, a = 0; a < e.length; a += 3) n = e[a], o = e[a + r], n ? x(r, n, o, i) : o(i);
              t._subscribers.length = 0;
            }
          }
          function x(e, r, n, o) {
            var i = t(n),
              a = void 0,
              s = void 0,
              c = !0;
            if (i) {
              try {
                a = n(o);
              } catch (t) {
                c = !1, s = t;
              }
              if (r === a) return void C(r, new TypeError("A promises callback cannot return that same promise."));
            } else a = o;
            r._state !== q || (i && c ? A(r, a) : !1 === c ? C(r, s) : e === E ? D(r, a) : e === k && C(r, a));
          }
          var I = 0;
          function N(t) {
            t[P] = I++, t._state = void 0, t._result = void 0, t._subscribers = [];
          }
          var M = function () {
              function t(t, r) {
                this._instanceConstructor = t, this.promise = new t(j), this.promise[P] || N(this.promise), e(r) ? (this.length = r.length, this._remaining = r.length, this._result = new Array(this.length), 0 === this.length ? D(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(r), 0 === this._remaining && D(this.promise, this._result))) : C(this.promise, new Error("Array Methods must be provided an Array"));
              }
              return t.prototype._enumerate = function (t) {
                for (var e = 0; this._state === q && e < t.length; e++) this._eachEntry(t[e], e);
              }, t.prototype._eachEntry = function (t, e) {
                var r = this._instanceConstructor,
                  n = r.resolve;
                if (n === w) {
                  var o = void 0,
                    i = void 0,
                    a = !1;
                  try {
                    o = t.then;
                  } catch (t) {
                    a = !0, i = t;
                  }
                  if (o === O && t._state !== q) this._settledAt(t._state, e, t._result);else if ("function" != typeof o) this._remaining--, this._result[e] = t;else if (r === H) {
                    var s = new r(j);
                    a ? C(s, i) : S(s, t, o), this._willSettleAt(s, e);
                  } else this._willSettleAt(new r(function (e) {
                    return e(t);
                  }), e);
                } else this._willSettleAt(n(t), e);
              }, t.prototype._settledAt = function (t, e, r) {
                var n = this.promise;
                n._state === q && (this._remaining--, t === k ? C(n, r) : this._result[e] = r), 0 === this._remaining && D(n, this._result);
              }, t.prototype._willSettleAt = function (t, e) {
                var r = this;
                L(t, void 0, function (t) {
                  return r._settledAt(E, e, t);
                }, function (t) {
                  return r._settledAt(k, e, t);
                });
              }, t;
            }(),
            H = function () {
              function e(t) {
                this[P] = I++, this._result = this._state = void 0, this._subscribers = [], j !== t && ("function" != typeof t && function () {
                  throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }(), this instanceof e ? function (t, e) {
                  try {
                    e(function (e) {
                      A(t, e);
                    }, function (e) {
                      C(t, e);
                    });
                  } catch (e) {
                    C(t, e);
                  }
                }(this, t) : function () {
                  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }());
              }
              return e.prototype.catch = function (t) {
                return this.then(null, t);
              }, e.prototype.finally = function (e) {
                var r = this,
                  n = r.constructor;
                return t(e) ? r.then(function (t) {
                  return n.resolve(e()).then(function () {
                    return t;
                  });
                }, function (t) {
                  return n.resolve(e()).then(function () {
                    throw t;
                  });
                }) : r.then(e, e);
              }, e;
            }();
          return H.prototype.then = O, H.all = function (t) {
            return new M(this, t).promise;
          }, H.race = function (t) {
            var r = this;
            return e(t) ? new r(function (e, n) {
              for (var o = t.length, i = 0; i < o; i++) r.resolve(t[i]).then(e, n);
            }) : new r(function (t, e) {
              return e(new TypeError("You must pass an array to race."));
            });
          }, H.resolve = w, H.reject = function (t) {
            var e = new this(j);
            return C(e, t), e;
          }, H._setScheduler = function (t) {
            o = t;
          }, H._setAsap = function (t) {
            i = t;
          }, H._asap = i, H.polyfill = function () {
            var t = void 0;
            if (void 0 !== a) t = a;else if ("undefined" != typeof self) t = self;else try {
              t = Function("return this")();
            } catch (t) {
              throw new Error("polyfill failed because global object is unavailable in this environment");
            }
            var e = t.Promise;
            if (e) {
              var r = null;
              try {
                r = Object.prototype.toString.call(e.resolve());
              } catch (t) {}
              if ("[object Promise]" === r && !e.cast) return;
            }
            t.Promise = H;
          }, H.Promise = H, H;
        }, "object" === s(e) ? t.exports = i() : void 0 === (o = "function" == typeof (n = i) ? n.call(e, r, e, t) : n) || (t.exports = o);
      },
      185: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = function (t, e) {
          var r = t.requestParams;
          return new Promise(function (n, o) {
            var i,
              a = new URLSearchParams(),
              l = function (t, e) {
                if ("object" === s(t) && void 0 !== t.length) for (var r = 0, n = t.length; r < n; r++) a.append(e + "[]", t[r]);else for (var o in t) {
                  var i = e ? e + "[" + o + "]" : o,
                    c = t[o];
                  null !== c && "object" === s(c) && "query" !== o ? l(c, i) : a.append(i, "query" !== o ? c : JSON.stringify(c));
                }
                return a.toString();
              };
            return r.headers["Content-Type"] = "application/json; charset=UTF-8", r.headers["X-User-Agent"] = "contentstack-delivery-javascript-web/" + c, r.body && "object" === s(r.body) && (delete r.body._method, "object" === s(r.body.query) && 0 === Object.keys(r.body.query).length && delete r.body.query, i = l(r.body)), u(t, i, e, n, o, e.retryDelay, e.retryLimit);
          });
        };
        var n,
          o = function (t, e) {
            if (t && t.__esModule) return t;
            if (null === t || "object" != s(t) && "function" != typeof t) return {
              default: t
            };
            var r = a(e);
            if (r && r.has(t)) return r.get(t);
            var n = {
                __proto__: null
              },
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var i in t) if ("default" !== i && {}.hasOwnProperty.call(t, i)) {
              var c = o ? Object.getOwnPropertyDescriptor(t, i) : null;
              c && (c.get || c.set) ? Object.defineProperty(n, i, c) : n[i] = t[i];
            }
            return n.default = t, r && r.set(t, n), n;
          }(r(925)),
          i = (n = r(54)) && n.__esModule ? n : {
            default: n
          };
        function a(t) {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap(),
            r = new WeakMap();
          return (a = function (t) {
            return t ? r : e;
          })(t);
        }
        function s(t) {
          return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, s(t);
        }
        var c = "3.25.3";
        function u(t, e, r, n, a) {
          var s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 300,
            c = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 5,
            l = t.requestParams,
            f = l.url + "?" + e,
            y = l.headers,
            p = o.mergeDeep({
              method: "GET",
              headers: y,
              timeout: 3e4
            }, r);
          r.debug && r.logHandler("info", {
            url: f,
            option: p
          });
          var d = {
              url: f,
              option: p
            },
            h = t.plugins;
          if (h && void 0 !== h) for (var v = 0; v < h.length; v++) "function" == typeof h[v].onRequest && (d = h[v].onRequest(t, d));
          (0, i.default)(d.url, d.option).then(function (o) {
            r.debug && r.logHandler("info", o);
            var i = o.json();
            if (o.ok && 200 === o.status) i.then(function (e) {
              for (var r = 0; r < h.length && "function" == typeof h[r].onResponse; r++) e = h[r].onResponse(t, d, o, e);
              n(e);
            });else {
              var l = o.status,
                f = o.statusText;
              i.then(function (i) {
                var y = {
                  error_message: i.error_message,
                  error_code: i.error_code,
                  errors: i.errors,
                  status: l,
                  statusText: f
                };
                r.retryCondition && r.retryCondition(o) ? function (o) {
                  if (0 === c) r.debug && r.logHandler("error", o), a(o);else {
                    var i = s;
                    c -= 1;
                    var l = r.retryLimit - c;
                    r.retryDelayOptions && (r.retryDelayOptions.base ? i = r.retryDelayOptions.base * l : r.retryDelayOptions.customBackoff && (i = r.retryDelayOptions.customBackoff(l, o))), function (t) {
                      return new Promise(function (e) {
                        setTimeout(e, t);
                      });
                    }(i).then(function () {
                      return u(t, e, r, n, a, s, c);
                    }).catch(function () {
                      return u(t, e, r, n, a, s, c);
                    });
                  }
                }(y) : (r.debug && r.logHandler("error", y), a(y));
              }).catch(function () {
                r.debug && r.logHandler("error", {
                  status: l,
                  statusText: f
                }), a({
                  status: l,
                  statusText: f
                });
              });
            }
          }).catch(function (t) {
            r.debug && r.logHandler("error", t), a(t);
          });
        }
      },
      209: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0;
        var n = function (t, e) {
          if (t && t.__esModule) return t;
          if (null === t || "object" != i(t) && "function" != typeof t) return {
            default: t
          };
          var r = o(e);
          if (r && r.has(t)) return r.get(t);
          var n = {
              __proto__: null
            },
            a = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s in t) if ("default" !== s && {}.hasOwnProperty.call(t, s)) {
            var c = a ? Object.getOwnPropertyDescriptor(t, s) : null;
            c && (c.get || c.set) ? Object.defineProperty(n, s, c) : n[s] = t[s];
          }
          return n.default = t, r && r.set(t, n), n;
        }(r(925));
        function o(t) {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap(),
            r = new WeakMap();
          return (o = function (t) {
            return t ? r : e;
          })(t);
        }
        function i(t) {
          return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, i(t);
        }
        function a(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, s(n.key), n);
          }
        }
        function s(t) {
          var e = function (t) {
            if ("object" != i(t) || !t) return t;
            var e = t[Symbol.toPrimitive];
            if (void 0 !== e) {
              var r = e.call(t, "string");
              if ("object" != i(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(t);
          }(t);
          return "symbol" == i(e) ? e : e + "";
        }
        e.default = function () {
          return t = function t(e) {
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), e && (this.object = function () {
              return e;
            }), this;
          }, (e = [{
            key: "toJSON",
            value: function () {
              return this.object() ? n.mergeDeep(JSON.parse(JSON.stringify({})), this.object()) : null;
            }
          }, {
            key: "get",
            value: function (t) {
              if (this.object() && t) return t.split(".").reduce(function (t, e) {
                return t[e];
              }, this.object());
            }
          }, {
            key: "getDownloadUrl",
            value: function (t) {
              if (this.object()) {
                var e = this.object().url ? this.object().url : null;
                return e ? e + "?disposition=" + (t && "string" == typeof t ? t : "attachment") : null;
              }
            }
          }]) && a(t.prototype, e), Object.defineProperty(t, "prototype", {
            writable: !1
          }), t;
          var t, e;
        }();
      },
      215: (t, e) => {
        function r(t) {
          return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, r(t);
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = function (t, e) {
          return n = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }, n(t, e);
        };
        function o(t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
          function r() {
            this.constructor = t;
          }
          n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }
        var i,
          a = function () {
            return a = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, a.apply(this, arguments);
          };
        "function" == typeof SuppressedError && SuppressedError, function (t) {
          t.BOLD = "bold", t.ITALIC = "italic", t.UNDERLINE = "underline", t.CLASSNAME_OR_ID = "classnameOrId", t.STRIKE_THROUGH = "strikethrough", t.INLINE_CODE = "inlineCode", t.SUBSCRIPT = "subscript", t.SUPERSCRIPT = "superscript", t.BREAK = "break";
        }(i || (i = {}));
        var s,
          c = i;
        !function (t) {
          t.DOCUMENT = "doc", t.PARAGRAPH = "p", t.LINK = "a", t.IMAGE = "img", t.EMBED = "embed", t.HEADING_1 = "h1", t.HEADING_2 = "h2", t.HEADING_3 = "h3", t.HEADING_4 = "h4", t.HEADING_5 = "h5", t.HEADING_6 = "h6", t.ORDER_LIST = "ol", t.UNORDER_LIST = "ul", t.LIST_ITEM = "li", t.FRAGMENT = "fragment", t.HR = "hr", t.TABLE = "table", t.TABLE_HEADER = "thead", t.TABLE_BODY = "tbody", t.TABLE_FOOTER = "tfoot", t.TABLE_ROW = "tr", t.TABLE_HEAD = "th", t.TABLE_DATA = "td", t.COL_GROUP = "colgroup", t.COL = "col", t.BLOCK_QUOTE = "blockquote", t.CODE = "code", t.TEXT = "text", t.REFERENCE = "reference";
        }(s || (s = {}));
        var u,
          l = s;
        function f(t, e, r) {
          return void 0 === e && (e = ["p", "a", "strong", "em", "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6", "sub", "u", "table", "thead", "tbody", "tr", "th", "td", "span", "fragment", "sup", "strike", "br", "img", "colgroup", "col", "div"]), void 0 === r && (r = ["href", "title", "target", "alt", "src", "class", "id", "style", "colspan", "rowspan", "content-type-uid", "data-sys-asset-uid", "sys-style-type", "data-type", "data-width", "data-rows", "data-cols", "data-mtec"]), (t = t.replace(/\n/g, "<br />")).replace(/<\/?([a-z][a-z0-9]*)\b[^<>]*>/gi, function (t, r) {
            return e.includes(r.toLowerCase()) ? t : "";
          }).replace(/<([a-z][a-z0-9]*)\b[^<>]*>/gi, function (t, n) {
            return e.includes(n.toLowerCase()) ? t.replace(/\s([a-z\-]+)=['"][^'"]*['"]/gi, function (t, e) {
              return r.includes(e.toLowerCase()) ? t : "";
            }) : t;
          });
        }
        var y,
          p = ((u = {})[l.DOCUMENT] = function (t) {
            return "";
          }, u[l.PARAGRAPH] = function (t, e) {
            return "<p".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</p>");
          }, u[l.LINK] = function (t, e) {
            var r = f(t.attrs.href || t.attrs.url);
            return t.attrs.target ? "<a".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ' href="').concat(r, '" target="').concat(t.attrs.target, '">').concat(f(e(t.children)), "</a>") : "<a".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ' href="').concat(r, '">').concat(f(e(t.children)), "</a>");
          }, u[l.IMAGE] = function (t, e) {
            var r = encodeURI(f(t.attrs.src || t.attrs.url));
            return "<img".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ' src="').concat(r, '" />').concat(f(e(t.children)));
          }, u[l.EMBED] = function (t, e) {
            var r = encodeURI(f(t.attrs.src || t.attrs.url));
            return "<iframe".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ' src="').concat(r, '">').concat(f(e(t.children)), "</iframe>");
          }, u[l.HEADING_1] = function (t, e) {
            return "<h1".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</h1>");
          }, u[l.HEADING_2] = function (t, e) {
            return "<h2".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</h2>");
          }, u[l.HEADING_3] = function (t, e) {
            return "<h3".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</h3>");
          }, u[l.HEADING_4] = function (t, e) {
            return "<h4".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</h4>");
          }, u[l.HEADING_5] = function (t, e) {
            return "<h5".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</h5>");
          }, u[l.HEADING_6] = function (t, e) {
            return "<h6".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</h6>");
          }, u[l.ORDER_LIST] = function (t, e) {
            return "<ol".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</ol>");
          }, u[l.FRAGMENT] = function (t, e) {
            return "<fragment>".concat(f(e(t.children)), "</fragment>");
          }, u[l.UNORDER_LIST] = function (t, e) {
            return "<ul".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</ul>");
          }, u[l.LIST_ITEM] = function (t, e) {
            return "<li".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</li>");
          }, u[l.HR] = function (t, e) {
            return "<hr>";
          }, u[l.TABLE] = function (t, e) {
            var r = "";
            if (t.attrs.colWidths && Array.isArray(t.attrs.colWidths)) {
              var n = t.attrs.colWidths.reduce(function (t, e) {
                return t + e;
              }, 0);
              r = "<".concat(l.COL_GROUP, ' data-width="').concat(n, '">'), t.attrs.colWidths.forEach(function (t) {
                var e = t / n * 100;
                r += "<".concat(l.COL, ' style="width:').concat(e.toFixed(2), '%"/>');
              }), r += "</".concat(l.COL_GROUP, ">");
            }
            return "<table".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "") + "".concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "") + "".concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">") + "".concat(r) + "".concat(f(e(t.children))) + "</table>";
          }, u[l.TABLE_HEADER] = function (t, e) {
            return "<thead".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</thead>");
          }, u[l.TABLE_BODY] = function (t, e) {
            return "<tbody".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</tbody>");
          }, u[l.TABLE_FOOTER] = function (t, e) {
            return "<tfoot".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</tfoot>");
          }, u[l.TABLE_ROW] = function (t, e) {
            return "<tr".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</tr>");
          }, u[l.TABLE_HEAD] = function (t, e) {
            return t.attrs.void ? "" : "<th" + "".concat(t.attrs.rowSpan ? ' rowspan="'.concat(t.attrs.rowSpan, '"') : "") + "".concat(t.attrs.colSpan ? ' colspan="'.concat(t.attrs.colSpan, '"') : "") + "".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "") + "".concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "") + "".concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children))) + "</th>";
          }, u[l.TABLE_DATA] = function (t, e) {
            return t.attrs.void ? "" : "<td" + "".concat(t.attrs.rowSpan ? ' rowspan="'.concat(t.attrs.rowSpan, '"') : "") + "".concat(t.attrs.colSpan ? ' colspan="'.concat(t.attrs.colSpan, '"') : "") + "".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "") + "".concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "") + "".concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children))) + "</td>";
          }, u[l.BLOCK_QUOTE] = function (t, e) {
            return "<blockquote".concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</blockquote>");
          }, u[l.CODE] = function (t, e) {
            return "<code".concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ">").concat(f(e(t.children)), "</code>");
          }, u.reference = function (t, e) {
            var r, n, o, i, a;
            if ("asset" === t.attrs.type) {
              var s = encodeURI(t.attrs["asset-link"]),
                c = null === (n = null === (r = t.attrs) || void 0 === r ? void 0 : r["redactor-attributes"]) || void 0 === n ? void 0 : n.alt,
                u = t.attrs.link,
                l = t.attrs.target || "",
                y = (null === (i = null === (o = t.attrs) || void 0 === o ? void 0 : o["redactor-attributes"]) || void 0 === i ? void 0 : i["asset-caption"]) || (null === (a = t.attrs) || void 0 === a ? void 0 : a["asset-caption"]) || "",
                p = t.attrs.style,
                d = t.attrs["asset-uid"],
                h = "<img".concat(d ? ' asset_uid="'.concat(d, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(f(t.attrs["class-name"]), '"') : "").concat(s ? ' src="'.concat(f(s), '"') : "").concat(c ? ' alt="'.concat(c, '"') : "").concat("_blank" === l ? ' target="_blank"' : "").concat(p ? ' style="'.concat(p, '"') : "", " />");
              return "<figure".concat(p ? ' style="'.concat(p, '"') : "", ">") + (u ? '<a href="'.concat(u, '" target="').concat(l || "", '">') : "") + h + (u ? "</a>" : "") + (y ? "<figcaption>".concat(y, "</figcaption>") : "") + "</figure>";
            }
            return "";
          }, u.default = function (t, e) {
            return f(e(t.children));
          }, u[c.BOLD] = function (t) {
            return "<strong>".concat(f(t), "</strong>");
          }, u[c.ITALIC] = function (t) {
            return "<em>".concat(f(t), "</em>");
          }, u[c.UNDERLINE] = function (t) {
            return "<u>".concat(f(t), "</u>");
          }, u[c.STRIKE_THROUGH] = function (t) {
            return "<strike>".concat(f(t), "</strike>");
          }, u[c.INLINE_CODE] = function (t) {
            return "<span data-type='inlineCode'>".concat(f(t), "</span>");
          }, u[c.SUBSCRIPT] = function (t) {
            return "<sub>".concat(f(t), "</sub>");
          }, u[c.SUPERSCRIPT] = function (t) {
            return "<sup>".concat(f(t), "</sup>");
          }, u[c.BREAK] = function (t) {
            return "<br />".concat(f(t));
          }, u[c.CLASSNAME_OR_ID] = function (t, e, r) {
            return "<span".concat(e ? ' class="'.concat(e, '"') : "").concat(r ? ' id="'.concat(r, '"') : "", ">").concat(f(t), "</span>");
          }, u);
        !function (t) {
          t.BLOCK = "block", t.INLINE = "inline", t.LINK = "link", t.DISPLAY = "display", t.DOWNLOAD = "download";
        }(y || (y = {}));
        var d,
          h = y,
          v = ((d = {})[h.BLOCK] = function (t) {
            var e = f(t.title || t.uid),
              r = f(t._content_type_uid || (t.system ? t.system.content_type_uid : ""));
            return "<div><p>".concat(e, "</p><p>Content type: <span>").concat(r, "</span></p></div>");
          }, d[h.INLINE] = function (t) {
            var e = f(t.title || t.uid);
            return "<span>".concat(e, "</span>");
          }, d[h.LINK] = function (t, e) {
            var r = encodeURI(f(t.url || "undefined")),
              n = f(e.text || t.title || t.uid || (t.system ? t.system.uid : ""));
            return '<a href="'.concat(r, '">').concat(n, "</a>");
          }, d[h.DISPLAY] = function (t, e) {
            var r = encodeURI(f(t.url || "undefined")),
              n = f(e.attributes.alt || t.title || t.filename || t.uid || (t.system ? t.system.uid : ""));
            return '<img src="'.concat(r, '" alt="').concat(n, '" />');
          }, d[h.DOWNLOAD] = function (t, e) {
            var r = encodeURI(f(t.url || "undefined")),
              n = f(e.text || t.title || t.uid || (t.system ? t.system.content_type_uid : ""));
            return '<a href="'.concat(r, '">').concat(n, "</a>");
          }, d);
        function _(t, e) {
          return "entry" === t.itemType ? (r = t.itemUid, n = t.contentTypeUid, void 0 === (o = e) && (o = []), o.filter(function (t) {
            if (t.uid && t.uid === r && t._content_type_uid === n || t.system && t.system.uid === r && t.system.content_type_uid === n) return t;
          })) : function (t, e) {
            return void 0 === e && (e = []), e.filter(function (e) {
              if (e.uid && e.uid === t || e.system && e.system.uid === t) return e;
            });
          }(t.itemUid, e);
          var r, n, o;
        }
        function m(t, e) {
          if (t && void 0 !== t && e && void 0 !== e && void 0 !== e._embedded_items) {
            var r = e;
            return _(t, Object.values(r._embedded_items || []).reduce(function (t, e) {
              return t.concat(e);
            }, []));
          }
          return [];
        }
        function b(t, e, r) {
          if (!t && void 0 === t || !e && void 0 === e) return "";
          if (r && void 0 !== r[e.styleType]) {
            var n = r[e.styleType];
            if (void 0 !== e.attributes["data-sys-content-type-uid"] && "function" != typeof n && void 0 !== n[e.attributes["data-sys-content-type-uid"]]) return n[e.attributes["data-sys-content-type-uid"]](t, e);
            if (void 0 !== e.attributes["data-sys-content-type-uid"] && "function" != typeof n && void 0 !== n.$default) return n.$default(t, e);
            if (void 0 !== e.contentTypeUid && "function" != typeof n && void 0 !== n[e.contentTypeUid]) return n[e.contentTypeUid](t, e);
            if (void 0 !== e.contentTypeUid && "function" != typeof n && void 0 !== n.$default) return n.$default(t, e);
            if ("function" == typeof n) return n(t, e);
          }
          return (0, v[e.styleType])(t, e);
        }
        function g(t, e) {
          for (var r = 0, n = t; r < n.length; r++) e(n[r]);
        }
        function O(t, e, r) {
          if (!(t instanceof Array) && "doc" !== t.type) return t;
          if (t instanceof Array) {
            var n = [];
            return t.forEach(function (t) {
              n.push(O(t, e, r));
            }), n;
          }
          var o = a(a({}, p), e);
          return w(t.children, o, r);
        }
        function w(t, e, r) {
          return t.map(function (t) {
            return function (t, e, r) {
              var n;
              if ((null === (n = null == t ? void 0 : t.attrs) || void 0 === n ? void 0 : n.style) && (t.attrs.style = function (t) {
                if (!t) return "";
                if ("string" == typeof t) return t;
                var e = "";
                for (var r in t) if (t.hasOwnProperty(r)) {
                  var n = t[r];
                  e += "".concat(r, ":").concat(n, ";");
                }
                return e;
              }(t.attrs.style)), t.type) {
                if ("reference" === t.type) return function (t, e, r) {
                  if (("entry" === t.attrs.type || "asset" === t.attrs.type) && "link" === t.attrs["display-type"]) {
                    var n = t.children ? w(t.children, e, r) : "",
                      o = "".concat(t.attrs.style ? ' style="'.concat(t.attrs.style, '"') : "").concat(t.attrs["class-name"] ? ' class="'.concat(t.attrs["class-name"], '"') : "").concat(t.attrs.id ? ' id="'.concat(t.attrs.id, '"') : "", ' href="').concat(t.attrs.href || t.attrs.url, '"');
                    return t.attrs.target && (o += ' target="'.concat(t.attrs.target, '"')), "asset" == t.attrs.type && (o += ' type="asset" content-type-uid="sys_assets" '.concat(t.attrs["asset-uid"] ? 'data-sys-asset-uid="'.concat(t.attrs["asset-uid"], '"') : "", ' sys-style-type="download"')), "<a".concat(o, ">").concat(n, "</a>");
                  }
                  function i(t) {
                    return e[t.type](t, void 0);
                  }
                  if (!r && void 0 !== e[t.type]) return i(t);
                  if (!r) return "";
                  var a,
                    s = (a = t.attrs, {
                      text: (t.children && t.children.length > 0 ? t.children[0] : {}).text,
                      itemUid: a["entry-uid"] || a["asset-uid"],
                      itemType: a.type,
                      styleType: a["display-type"],
                      attributes: a,
                      contentTypeUid: a["content-type-uid"]
                    }),
                    c = r(s);
                  return c || void 0 === e[t.type] ? b(c, s, e) : i(t);
                }(t, e, r);
                var o = function (t) {
                  return w(t, e, r);
                };
                return void 0 !== e[t.type] ? e[t.type](t, o) : e.default(t, o);
              }
              return function (t, e) {
                var r = P(t.text);
                return (t.classname || t.id) && (r = e[c.CLASSNAME_OR_ID](r, t.classname, t.id)), t.break && (r = e[c.BREAK](r)), t.superscript && (r = e[c.SUPERSCRIPT](r)), t.subscript && (r = e[c.SUBSCRIPT](r)), t.inlineCode && (r = e[c.INLINE_CODE](r)), t.strikethrough && (r = e[c.STRIKE_THROUGH](r)), t.underline && (r = e[c.UNDERLINE](r)), t.italic && (r = e[c.ITALIC](r)), t.bold && (r = e[c.BOLD](r)), r;
              }(t, e);
            }(t, e, r);
          }).join("");
        }
        function P(t) {
          return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
        }
        var j = ['"', "'", ">", "<", "/", "="];
        function q(t) {
          return {
            text: t["#text"],
            itemUid: t["data-sys-entry-uid"] || t["data-sys-asset-uid"],
            itemType: t.type,
            styleType: t["sys-style-type"],
            attributes: t,
            contentTypeUid: t["data-sys-content-type-uid"]
          };
        }
        function E(t) {
          for (var e = {}, r = 0; r < t.attributes.length; r++) e[t.attributes.item(r).name] = t.attributes.item(r).value;
          return t.childNodes.forEach(function (t) {
            var r = t;
            e = a(a({}, e), function (t) {
              var e = {};
              return 3 === t.nodeType ? e["#text"] = t.textContent : 1 === t.nodeType && (e[t.nodeName.toLowerCase()] = E(t)), e;
            }(r));
          }), e;
        }
        var k = "documentfragmentcontainer";
        function S(t, e, r) {
          A(t.split("."), e, r);
        }
        function A(t, e, n) {
          if (t) {
            var o = t[0];
            if (1 === t.length && e[o]) e[o] = n(e[o]);else if (t.length > 0 && e[o]) {
              var i = t.slice(1);
              if (Array.isArray(e[o])) for (var a = 0, s = e[o]; a < s.length; a++) A(i, s[a], n);else "object" === r(e[o]) && A(i, e[o], n);
            }
          }
        }
        function T(t, e) {
          if (!t || void 0 === t) return "";
          if ("string" == typeof t) {
            var r = t;
            return t.forEachEmbeddedItem(function (t, n) {
              r = function (t, e, r, n) {
                var o = b(m(r, n.entry)[0], r, n.renderOption);
                return t.replace(e, o);
              }(r, t, n, e);
            }), r;
          }
          var n = [];
          return t.forEach(function (t) {
            n.push(T(t, e));
          }), n;
        }
        String.prototype.forEachEmbeddedItem = function (t) {
          var e = "<".concat(k, ">").concat(this.toString(), "</").concat(k, ">"),
            r = new DOMParser().parseFromString(e, "text/html");
          r.querySelectorAll(".embedded-entry").forEach(function (e) {
            t(e.outerHTML, q(E(e)));
          }), r.querySelectorAll(".embedded-asset").forEach(function (e) {
            t(e.outerHTML, q(E(e)));
          });
        };
        var D = function () {},
          C = function (t) {
            function e() {
              var e = t.call(this) || this;
              return e.type = l.DOCUMENT, e;
            }
            return o(e, t), e;
          }(D),
          L = function (t) {
            function e(e) {
              var r = t.call(this) || this;
              return r.text = e, r;
            }
            return o(e, t), e;
          }(D),
          R = {
            jsonToHTML: function t(e) {
              e.entry instanceof Array ? g(e.entry, function (r) {
                t({
                  entry: r,
                  paths: e.paths,
                  renderOption: e.renderOption
                });
              }) : function (t) {
                for (var e = 0, r = t.paths; e < r.length; e++) S(r[e], t.entry, function (e) {
                  if (e && e.json) {
                    var r = e.embedded_itemsConnection ? e.embedded_itemsConnection.edges : [],
                      n = Object.values(r || []).reduce(function (t, e) {
                        return t.concat(e.node);
                      }, []);
                    return O(e.json, t.renderOption, function (t) {
                      return _(t, n)[0];
                    });
                  }
                  return e;
                });
              }({
                entry: e.entry,
                paths: e.paths,
                renderOption: e.renderOption
              });
            }
          };
        function x(t, e, n, o, i) {
          var a = {};
          i.metaKey;
          var s = i.shouldApplyVariant,
            c = i._applied_variants;
          return Object.entries(t).forEach(function (t) {
            var u = t[0],
              l = t[1];
            if ("$" !== u) {
              var f = l && "object" === r(l) && l._metadata && l._metadata.uid ? l._metadata.uid : "",
                y = i.shouldApplyVariant ? "".concat(i.metaKey ? i.metaKey + "." : "").concat(u) : "";
              f && y && (y = y + "." + f), "object" === r(l) ? (Array.isArray(l) ? l.forEach(function (t, p) {
                var d,
                  h = "".concat(u, "__").concat(p),
                  v = "".concat(u, "__parent");
                if (f = l && "object" === r(l) && t._metadata && t._metadata.uid ? t._metadata.uid : "", y = i.shouldApplyVariant ? "".concat(i.metaKey ? i.metaKey + "." : "").concat(u) : "", f && y && (y = y + "." + f), a[h] = I("".concat(e, ".").concat(u, ".").concat(p), n, {
                  _applied_variants: c,
                  shouldApplyVariant: s,
                  metaKey: y
                }), a[v] = function (t, e) {
                  return e ? {
                    "data-cslp-parent-field": t
                  } : "data-cslp-parent-field=".concat(t);
                }("".concat(e, ".").concat(u), n), null != t && void 0 !== t._content_type_uid && void 0 !== t.uid) {
                  var _ = t._applied_variants || (null === (d = null == t ? void 0 : t.system) || void 0 === d ? void 0 : d.applied_variants) || c,
                    m = !!_;
                  l[p].$ = x(t, "".concat(t._content_type_uid, ".").concat(t.uid, ".").concat(t.locale || o), n, o, {
                    _applied_variants: _,
                    shouldApplyVariant: m,
                    metaKey: ""
                  });
                } else "object" === r(t) && (t.$ = x(t, "".concat(e, ".").concat(u, ".").concat(p), n, o, {
                  _applied_variants: c,
                  shouldApplyVariant: s,
                  metaKey: y
                }));
              }) : l && (l.$ = x(l, "".concat(e, ".").concat(u), n, o, {
                _applied_variants: c,
                shouldApplyVariant: s,
                metaKey: y
              })), a[u] = I("".concat(e, ".").concat(u), n, {
                _applied_variants: c,
                shouldApplyVariant: s,
                metaKey: y
              })) : a[u] = I("".concat(e, ".").concat(u), n, {
                _applied_variants: c,
                shouldApplyVariant: s,
                metaKey: y
              });
            }
          }), a;
        }
        function I(t, e, r) {
          if (r.shouldApplyVariant && r._applied_variants && r._applied_variants[r.metaKey]) {
            var n = r._applied_variants[r.metaKey],
              o = ("v2:" + t).split(".");
            o[1] = o[1] + "_" + n, t = o.join(".");
          }
          return e ? {
            "data-cslp": t
          } : "data-cslp=".concat(t);
        }
        function N(t) {
          for (var e in t) {
            var n = t[e];
            n instanceof Array ? n.forEach(function (t) {
              M(t);
            }) : n && "object" === r(n) && M(n);
          }
        }
        function M(t) {
          var e,
            r = H(t);
          r && (null === (e = null == r ? void 0 : r.embedded_itemsConnection) || void 0 === e ? void 0 : e.edges).forEach(function (t) {
            var e,
              n,
              o,
              i = t.node;
            if ((null == i ? void 0 : i.url) && (null == i ? void 0 : i.filename)) {
              if (!(null === (e = null == i ? void 0 : i.system) || void 0 === e ? void 0 : e.uid)) throw new Error("Asset UID not found in the response");
              (null === (o = null === (n = null == r ? void 0 : r.json) || void 0 === n ? void 0 : n.children) || void 0 === o ? void 0 : o.find(function (t) {
                return t.attrs["asset-uid"] === i.system.uid;
              })).attrs["asset-link"] = i.url;
            }
          });
        }
        function H(t) {
          if (t && t.embedded_itemsConnection) return t;
          for (var e in t) if (t[e] && "object" === r(t[e])) {
            var n = H(t[e]);
            if (n) return n;
          }
        }
        e.Document = C, e.GQL = R, e.MarkType = c, e.Node = D, e.NodeType = l, e.StyleType = h, e.TextNode = L, e.addEditableTags = function (t, e, r, n) {
          var o;
          if (void 0 === n && (n = "en-us"), t) {
            var i = t._applied_variants || (null === (o = null == t ? void 0 : t.system) || void 0 === o ? void 0 : o.applied_variants) || null;
            t.$ = x(t, "".concat(e, ".").concat(t.uid, ".").concat(n), r, n, {
              _applied_variants: i,
              shouldApplyVariant: !!i,
              metaKey: ""
            });
          }
        }, e.attributeToString = function (t) {
          var e = "",
            n = function (n) {
              if (Object.prototype.hasOwnProperty.call(t, n)) {
                if (j.some(function (t) {
                  return n.includes(t);
                })) return "continue";
                var o = t[n];
                if (Array.isArray(o)) o = o.join(", ");else if ("object" === r(o)) {
                  var i = "";
                  for (var a in o) if (Object.prototype.hasOwnProperty.call(o, a)) {
                    var s = o[a];
                    null != s && "" !== s && (i += "".concat(a, ":").concat(s, "; "));
                  }
                  o = i;
                }
                e += " ".concat(n, '="').concat(P(String(o)), '"');
              }
            };
          for (var o in t) n(o);
          return e;
        }, e.jsonToHTML = function t(e) {
          e.entry instanceof Array ? g(e.entry, function (r) {
            t({
              entry: r,
              paths: e.paths,
              renderOption: e.renderOption
            });
          }) : function (t) {
            for (var e = 0, r = t.paths; e < r.length; e++) S(r[e], t.entry, function (e) {
              return O(e, t.renderOption, function (e) {
                return m(e, t.entry)[0];
              });
            });
          }({
            entry: e.entry,
            paths: e.paths,
            renderOption: e.renderOption
          });
        }, e.render = function (t) {
          function e(e, r) {
            S(e, r, function (e) {
              return T(e, {
                entry: r,
                renderOption: t.renderOption
              });
            });
          }
          function r(r) {
            t.paths && 0 !== t.paths.length ? t.paths.forEach(function (t) {
              e(t, r);
            }) : Object.keys(a({}, r._embedded_items)).forEach(function (t) {
              e(t, r);
            });
          }
          t.entry instanceof Array ? t.entry.forEach(function (t) {
            r(t);
          }) : r(t.entry);
        }, e.renderContent = T, e.updateAssetURLForGQL = function (t) {
          try {
            var e = null == t ? void 0 : t.data;
            for (var r in e) "items" in e[r] ? e[r].items.forEach(function (t) {
              N(t);
            }) : N(e[r]);
          } catch (t) {
            console.error("Error in updating asset URL for GQL response", t);
          }
        };
      },
      241: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0, e.default = {
          protocol: "https",
          host: "cdn.contentstack.io",
          port: 443,
          version: "v3",
          urls: {
            sync: "/stacks/sync",
            content_types: "/content_types/",
            entries: "/entries/",
            assets: "/assets/",
            environments: "/environments/",
            taxonomies: "/taxonomies/entries"
          },
          live_preview: {
            enable: !1,
            host: "rest-preview.contentstack.com"
          }
        };
      },
      275: (t, e, r) => {
        function n(t) {
          return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, n(t);
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0;
        var o,
          i = (o = r(318)) && o.__esModule ? o : {
            default: o
          };
        function a() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (a = function () {
            return !!t;
          })();
        }
        function s(t) {
          return s = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          }, s(t);
        }
        function c(t, e) {
          return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
            return t.__proto__ = e, t;
          }, c(t, e);
        }
        var u = function (t) {
          return function (e, r, n) {
            if (e && r && "string" == typeof e && void 0 !== r) return this._query.query[e] = this._query.query.file_size || {}, this._query.query[e][t] = r, n && "number" == typeof n && (this._query.query[e].levels = n), this;
            this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
          };
        };
        e.default = function (t) {
          function e() {
            var t;
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, e), (t = function (t, e, r) {
              return e = s(e), function (t, e) {
                if (e && ("object" == n(e) || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return function (t) {
                  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return t;
                }(t);
              }(t, a() ? Reflect.construct(e, r || [], s(t).constructor) : e.apply(t, r));
            }(this, e)).above = u("$above"), t.equalAndAbove = u("$eq_above"), t.below = u("$below"), t.equalAndBelow = u("$eq_below"), t;
          }
          return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(t, "prototype", {
              writable: !1
            }), e && c(t, e);
          }(e, t), function (t) {
            return Object.defineProperty(t, "prototype", {
              writable: !1
            }), t;
          }(e);
        }(i.default);
      },
      285: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0;
        var n,
          o = (n = r(641)) && n.__esModule ? n : {
            default: n
          },
          i = {
            providers: function (t) {
              if (t) return o.default;
              console.error("Kindly provide valid provider.");
            },
            policies: {
              IGNORE_CACHE: -1,
              ONLY_NETWORK: 0,
              CACHE_ELSE_NETWORK: 1,
              NETWORK_ELSE_CACHE: 2,
              CACHE_THEN_NETWORK: 3
            }
          };
        e.default = i;
      },
      318: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0;
        var n,
          o = function (t, e) {
            if (t && t.__esModule) return t;
            if (null === t || "object" != h(t) && "function" != typeof t) return {
              default: t
            };
            var r = a(e);
            if (r && r.has(t)) return r.get(t);
            var n = {
                __proto__: null
              },
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var i in t) if ("default" !== i && {}.hasOwnProperty.call(t, i)) {
              var s = o ? Object.getOwnPropertyDescriptor(t, i) : null;
              s && (s.get || s.set) ? Object.defineProperty(n, i, s) : n[i] = t[i];
            }
            return n.default = t, r && r.set(t, n), n;
          }(r(925)),
          i = (n = r(42)) && n.__esModule ? n : {
            default: n
          };
        function a(t) {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap(),
            r = new WeakMap();
          return (a = function (t) {
            return t ? r : e;
          })(t);
        }
        function s(t, e) {
          var r = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e && (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), r.push.apply(r, n);
          }
          return r;
        }
        function c(t) {
          for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? arguments[e] : {};
            e % 2 ? s(Object(r), !0).forEach(function (e) {
              u(t, e, r[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (e) {
              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
            });
          }
          return t;
        }
        function u(t, e, r) {
          return (e = f(e)) in t ? Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = r, t;
        }
        function l(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, f(n.key), n);
          }
        }
        function f(t) {
          var e = function (t) {
            if ("object" != h(t) || !t) return t;
            var e = t[Symbol.toPrimitive];
            if (void 0 !== e) {
              var r = e.call(t, "string");
              if ("object" != h(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(t);
          }(t);
          return "symbol" == h(e) ? e : e + "";
        }
        function y() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (y = function () {
            return !!t;
          })();
        }
        function p(t) {
          return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          }, p(t);
        }
        function d(t, e) {
          return d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
            return t.__proto__ = e, t;
          }, d(t, e);
        }
        function h(t) {
          return h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, h(t);
        }
        var v = function (t) {
            return function (e, r) {
              if (e && r && "string" == typeof e && void 0 !== r) return this._query.query[e] = this._query.query.file_size || {}, this._query.query[e][t] = r, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            };
          },
          _ = function (t) {
            var e = t ? "$in" : "$nin";
            return function (t, r) {
              if (t && r && "string" == typeof t && Array.isArray(r)) return this._query.query[t] = this._query.query[t] || {}, this._query.query[t][e] = this._query.query[t][e] || [], this._query.query[t][e] = this._query.query[t][e].concat(r), this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            };
          },
          m = function (t) {
            return function (e) {
              if (e && "string" == typeof e) return this._query.query[e] = this._query.query[e] || {}, this._query.query[e].$exists = t, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            };
          },
          b = function (t) {
            return function () {
              for (var e = [], r = 0, n = arguments.length; r < n; r++) arguments[r] instanceof P && arguments[r]._query.query ? e.push(arguments[r]._query.query) : "object" === h(arguments[r]) && e.push(arguments[r]);
              return this._query.query[t] ? this._query.query[t] = this._query.query[t].concat(e) : this._query.query[t] = e, this;
            };
          },
          g = function (t) {
            return function (e) {
              if (e && "string" == typeof e) return this._query[t] = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Argument should be a string.");
            };
          },
          O = function (t) {
            return function (e) {
              if ("number" == typeof e) return this._query[t] = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Argument should be a number.");
            };
          };
        function w(t, e, r, n) {
          var o;
          switch (t) {
            case "asset":
              o = n + e.urls.assets;
              break;
            case "taxonomy":
              o = n + e.urls.taxonomies;
              break;
            default:
              o = n + e.urls.content_types + r + e.urls.entries;
          }
          return o;
        }
        var P = e.default = function (t) {
          function e() {
            var t;
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, e), (t = function (t, e, r) {
              return e = p(e), function (t, e) {
                if (e && ("object" == h(e) || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return function (t) {
                  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return t;
                }(t);
              }(t, y() ? Reflect.construct(e, r || [], p(t).constructor) : e.apply(t, r));
            }(this, e))._query = t._query || {}, t._query.query = t._query.query || {}, t.lessThan = v("$lt"), t.lessThanOrEqualTo = v("$lte"), t.greaterThan = v("$gt"), t.greaterThanOrEqualTo = v("$gte"), t.notEqualTo = v("$ne"), t.containedIn = _(!0), t.notContainedIn = _(!1), t.exists = m(!0), t.notExists = m(!1), t.ascending = g("asc"), t.descending = g("desc"), t.beforeUid = g("before_uid"), t.afterUid = g("after_uid"), t.skip = O("skip"), t.limit = O("limit"), t.or = b("$or"), t.and = b("$and"), t;
          }
          return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(t, "prototype", {
              writable: !1
            }), e && d(t, e);
          }(e, t), function (t, e) {
            return e && l(t.prototype, e), Object.defineProperty(t, "prototype", {
              writable: !1
            }), t;
          }(e, [{
            key: "equalTo",
            value: function (t, e) {
              if (t && "string" == typeof t) return this._query.query[t] = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            }
          }, {
            key: "where",
            value: function (t, e) {
              if (t && "string" == typeof t) return this._query.query[t] = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            }
          }, {
            key: "count",
            value: function () {
              var t = this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version,
                e = w(this.type, this.config, this.content_type_uid, t);
              return this._query.count = !0, this.requestParams = {
                method: "POST",
                headers: o.mergeDeep({}, this.headers),
                url: e,
                body: {
                  _method: "GET",
                  query: this._query
                }
              }, this;
            }
          }, {
            key: "query",
            value: function (t) {
              if ("object" === h(t)) return this._query.query = o.mergeDeep(this._query.query, t), this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters");
            }
          }, {
            key: "referenceIn",
            value: function (t, r) {
              var n = {};
              return r instanceof e && r._query.query ? n.$in_query = r._query.query : "object" === h(r) && (n.$in_query = r), this._query.query[t] ? this._query.query[t] = this._query.query[t].concat(n) : this._query.query[t] = n, this;
            }
          }, {
            key: "referenceNotIn",
            value: function (t, r) {
              var n = {};
              return r instanceof e && r._query.query ? n.$nin_query = r._query.query : "object" === h(r) && (n.$nin_query = r), this._query.query[t] ? this._query.query[t] = this._query.query[t].concat(n) : this._query.query[t] = n, this;
            }
          }, {
            key: "tags",
            value: function (t) {
              if (Array.isArray(t)) return this._query.tags = t, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters");
            }
          }, {
            key: "includeReferenceContentTypeUID",
            value: function () {
              return this._query.include_reference_content_type_uid = !0, this;
            }
          }, {
            key: "includeCount",
            value: function () {
              return this._query.include_count = !0, this;
            }
          }, {
            key: "addParam",
            value: function (t, e) {
              if (t && e && "string" == typeof t && "string" == typeof e) return this._query[t] = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            }
          }, {
            key: "getQuery",
            value: function () {
              return this._query.query || {};
            }
          }, {
            key: "regex",
            value: function (t, e, r) {
              if (t && e && "string" == typeof t && "string" == typeof e) return this._query.query[t] = {
                $regex: e
              }, r && (this._query.query[t].$options = r), this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            }
          }, {
            key: "search",
            value: function (t) {
              if (t && "string" == typeof t) return this._query.typeahead = t, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters.");
            }
          }, {
            key: "find",
            value: function (t) {
              var e = this.config.host + ":" + this.config.port;
              this.type && "asset" !== this.type && this.live_preview && !0 === this.live_preview.enable && this.live_preview.live_preview && "init" !== this.live_preview.live_preview && (e = this.live_preview.host);
              var r = this.config.protocol + "://" + e + "/" + this.config.version,
                n = w(this.type, this.config, this.content_type_uid, r);
              this.requestParams = {
                method: "POST",
                headers: o.mergeDeep({}, this.headers),
                url: n,
                body: {
                  _method: "GET",
                  query: this._query
                }
              };
              var i = o.mergeDeep(this.fetchOptions, t);
              return o.sendRequest(o.mergeDeep({}, this), i);
            }
          }, {
            key: "variants",
            value: function (t) {
              return Array.isArray(t) && t.length > 0 ? this.headers["x-cs-variant-uid"] = t.join(",") : this.headers["x-cs-variant-uid"] = t, this;
            }
          }, {
            key: "findOne",
            value: function () {
              var t = this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version;
              this.type && "asset" !== this.type && this.live_preview && !0 === this.live_preview.enable && this.live_preview.live_preview && "init" !== this.live_preview.live_preview && (t = this.config.protocol + "://" + this.live_preview.host + "/" + this.config.version);
              var e = w(this.type, this.config, this.content_type_uid, t);
              this.singleEntry = !0, this._query.limit = 1, this.requestParams = {
                method: "POST",
                headers: o.mergeDeep({}, this.headers),
                url: e,
                body: {
                  _method: "GET",
                  query: this._query
                }
              };
              var r = o.mergeDeep({}, this.fetchOptions);
              return o.sendRequest(o.mergeDeep({}, this), r).catch(function (t) {
                return t.status ? Promise.reject(c(c({}, t), {}, {
                  http_code: t.status,
                  http_message: t.statusText || "An error occurred"
                })) : Promise.reject(t);
              });
            }
          }]);
        }(i.default);
      },
      348: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0;
        var n = y(r(241)),
          o = function (t, e) {
            if (t && t.__esModule) return t;
            if (null === t || "object" != p(t) && "function" != typeof t) return {
              default: t
            };
            var r = f(e);
            if (r && r.has(t)) return r.get(t);
            var n = {
                __proto__: null
              },
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var i in t) if ("default" !== i && {}.hasOwnProperty.call(t, i)) {
              var a = o ? Object.getOwnPropertyDescriptor(t, i) : null;
              a && (a.get || a.set) ? Object.defineProperty(n, i, a) : n[i] = t[i];
            }
            return n.default = t, r && r.set(t, n), n;
          }(r(925)),
          i = y(r(42)),
          a = y(r(537)),
          s = y(r(318)),
          c = y(r(275)),
          u = y(r(185)),
          l = y(r(285));
        function f(t) {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap(),
            r = new WeakMap();
          return (f = function (t) {
            return t ? r : e;
          })(t);
        }
        function y(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
        function p(t) {
          return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, p(t);
        }
        function d(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, h(n.key), n);
          }
        }
        function h(t) {
          var e = function (t) {
            if ("object" != p(t) || !t) return t;
            var e = t[Symbol.toPrimitive];
            if (void 0 !== e) {
              var r = e.call(t, "string");
              if ("object" != p(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(t);
          }(t);
          return "symbol" == p(e) ? e : e + "";
        }
        var v = [408, 429];
        e.default = function () {
          return t = function t() {
            var e = this;
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.fetchOptions = {
              retryLimit: 5,
              retryCondition: function (t) {
                return !!v.includes(t.status);
              },
              debug: !1,
              logHandler: function (t, e) {
                "error" === t && e ? console.error("[error] ".concat(e)) : "warning" === t && e ? console.warn("[warning] ".concat(e)) : "info" === t && e && console.info("[info] ".concat(e));
              }
            }, this.config = JSON.parse(JSON.stringify(n.default)), this.plugins = [];
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
            switch (i[0].live_preview && !0 === i[0].live_preview.enable && null !== i[0].live_preview.management_token && i[0].live_preview.management_token && (this.config.live_preview.host = "api.contentstack.io"), i[0].region && void 0 !== i[0].region && "us" !== i[0].region && (this.config.host = i[0].region + "-cdn.contentstack.com", i[0].live_preview && !0 === i[0].live_preview.enable && (i[0].live_preview.management_token ? this.config.live_preview.host = i[0].region + "-api.contentstack.com" : this.config.live_preview.host = i[0].region + "-rest-preview.contentstack.com")), i[0].fetchOptions && void 0 !== i[0].fetchOptions && (this.fetchOptions = o.mergeDeep(this.fetchOptions, i[0].fetchOptions)), i[0].plugins && void 0 !== i[0].plugins && i[0].plugins.forEach(function (t) {
              e.plugins.push(t);
            }), this.cachePolicy = l.default.policies.IGNORE_CACHE, this.provider = l.default.providers("localstorage"), i.length) {
              case 1:
                if ("object" === p(i[0]) && "string" == typeof i[0].api_key && "string" == typeof i[0].delivery_token && "string" == typeof i[0].environment) return this.headers = {
                  api_key: i[0].api_key,
                  access_token: i[0].delivery_token
                }, "object" == p(i[0].live_preview) && (this.live_preview = o.mergeDeep(this.config.live_preview, i[0].live_preview), this.setLivePreviewTimelinePreviewForClient()), "string" == typeof i[0].branch && void 0 !== i[0].branch && (this.headers.branch = i[0].branch), "object" == p(i[0].early_access) && Array.isArray(i[0].early_access) && i[0].early_access.length > 0 && (this.headers["x-header-ea"] = i[0].early_access.join(",")), this.environment = i[0].environment, this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid object parameters. The specified API Key, Delivery Token, or Environment Name is invalid.");
              case 3:
                if (this.fetchOptions.debug && this.fetchOptions.logHandler("warning", "WARNING! Obsolete function called. Function 'Contentstack.Stack(api_key, delivery_token, environment)' has been deprecated, please use 'Contentstack.Stack({api_key, delivery_token, environment, region, branch, fetchOptions})' function instead!"), "string" == typeof i[0] && "string" == typeof i[1] && "string" == typeof i[2]) return this.headers = {
                  api_key: i[0],
                  access_token: i[1]
                }, this.environment = i[2], this;
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid string parameters.");
              case 4:
                return this.fetchOptions.debug && this.fetchOptions.logHandler("warning", "WARNING! Obsolete function called. Function 'Contentstack.Stack(api_key, delivery_token, environment)' has been deprecated, please use 'Contentstack.Stack({api_key, delivery_token, environment, region, branch, fetchOptions})' function instead!"), "string" == typeof i[0] && "string" == typeof i[1] && "string" == typeof i[2] ? (this.headers = {
                  api_key: i[0],
                  access_token: i[1]
                }, this.environment = i[2]) : this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid string parameters."), i[3] && ("string" == typeof i[3] && void 0 !== i[3] && "us" !== i[3] ? this.config.host = i[3] + "-cdn.contentstack.com" : "object" === p(i[3]) && (this.fetchOptions = o.mergeDeep(this.fetchOptions, i[3]))), this;
              case 5:
                return this.fetchOptions.debug && this.fetchOptions.logHandler("warning", "WARNING! Obsolete function called. Function 'Contentstack.Stack(api_key, delivery_token, environment)' has been deprecated, please use 'Contentstack.Stack({api_key, delivery_token, environment, region, branch, fetchOptions})' function instead!"), "string" == typeof i[0] && "string" == typeof i[1] && "string" == typeof i[2] ? (this.headers = {
                  api_key: i[0],
                  access_token: i[1]
                }, this.environment = i[2]) : this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid string parameters."), i[3] && ("string" == typeof i[3] && void 0 !== i[3] && "us" !== i[3] ? this.config.host = i[3] + "-cdn.contentstack.com" : "object" === p(i[3]) && (this.fetchOptions = o.mergeDeep(this.fetchOptions, i[3]))), i[4] && "object" === p(i[4]) && (this.fetchOptions = o.mergeDeep(this.fetchOptions, i[4])), this;
              default:
                this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide valid parameters to initialize the Contentstack javascript-SDK Stack.");
            }
          }, e = [{
            key: "setPort",
            value: function (t) {
              return "number" == typeof t && (this.config.port = t), this;
            }
          }, {
            key: "setProtocol",
            value: function (t) {
              return "string" == typeof t && ~["https", "http"].indexOf(t) && (this.config.protocol = t), this;
            }
          }, {
            key: "setHost",
            value: function (t) {
              return "string" == typeof t && t && (this.config.host = t), this;
            }
          }, {
            key: "setCachePolicy",
            value: function (t) {
              return "number" == typeof t && t >= -1 && t < 4 ? this._query ? this.queryCachePolicy = t : this.cachePolicy = t : this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide the valid policy"), this;
            }
          }, {
            key: "setLivePreviewTimelinePreviewForClient",
            value: function () {
              if (o.isBrowser()) {
                var t = new URL(document.location.toString()).searchParams;
                t.has("live_preview") && (this.live_preview.live_preview = t.get("live_preview")), t.has("release_id") ? this.headers.release_id = t.get("release_id") : delete this.headers.release_id, t.has("preview_timestamp") ? this.headers.preview_timestamp = t.get("preview_timestamp") : delete this.headers.preview_timestamp;
              }
            }
          }, {
            key: "livePreviewQuery",
            value: function (t) {
              this.live_preview && (this.live_preview.live_preview = t.live_preview || "init", this.live_preview.content_type_uid = t.content_type_uid, this.live_preview.entry_uid = t.entry_uid), t.hasOwnProperty("release_id") ? this.headers.release_id = t.release_id : delete this.headers.release_id, t.hasOwnProperty("preview_timestamp") ? this.headers.preview_timestamp = t.preview_timestamp : delete this.headers.preview_timestamp;
            }
          }, {
            key: "setCacheProvider",
            value: function (t) {
              return t && "object" === p(t) && (this.provider = t), this;
            }
          }, {
            key: "clearByQuery",
            value: function () {
              if (this.provider && "function" == typeof this.provider.clearByQuery) return this.provider.clearByQuery.apply(this.provider, arguments);
            }
          }, {
            key: "clearByContentType",
            value: function () {
              if (this.provider && "function" == typeof this.provider.clearByContentType) return this.provider.clearByContentType.apply(this.provider, arguments);
            }
          }, {
            key: "clearAll",
            value: function () {
              if (this.provider && "function" == typeof this.provider.clearAll) return this.provider.clearAll.apply(this.provider, arguments);
            }
          }, {
            key: "getCacheProvider",
            value: function () {
              return this.provider;
            }
          }, {
            key: "ContentType",
            value: function (t) {
              return t && "string" == typeof t && (this.content_type_uid = t, this.type = "contentType"), this;
            }
          }, {
            key: "Taxonomies",
            value: function () {
              return this.type = "taxonomy", o.merge(new c.default(), this);
            }
          }, {
            key: "Entry",
            value: function (t) {
              var e = new i.default();
              return t && "string" == typeof t && (e.entry_uid = t), o.merge(e, this);
            }
          }, {
            key: "fetch",
            value: function (t) {
              this.requestParams = {
                method: "POST",
                headers: o.mergeDeep({}, this.headers),
                plugins: this.plugins,
                url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.content_types + this.content_type_uid,
                body: {
                  _method: "GET",
                  environment: this.environment
                }
              };
              var e = o.mergeDeep(this.fetchOptions, t);
              return (0, u.default)(this, e);
            }
          }, {
            key: "Assets",
            value: function (t) {
              if (this.type = "asset", t && "string" == typeof t) {
                var e = new a.default();
                return e.asset_uid = t, o.merge(e, this);
              }
              return this;
            }
          }, {
            key: "Query",
            value: function () {
              var t = "contentType" === this.type ? new c.default() : new s.default();
              return o.merge(t, this);
            }
          }, {
            key: "getLastActivities",
            value: function () {
              return this.requestParams = {
                method: "POST",
                headers: o.mergeDeep({}, this.headers),
                url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.content_types,
                body: {
                  _method: "GET",
                  only_last_activity: !0,
                  environment: this.environment
                }
              }, (0, u.default)(this, this.fetchOptions);
            }
          }, {
            key: "getContentTypes",
            value: function () {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              if (this.requestParams = {
                method: "POST",
                headers: o.mergeDeep({}, this.headers),
                url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.content_types,
                body: {
                  _method: "GET",
                  environment: this.environment
                }
              }, t) for (var e in t) this.requestParams.body[e] = t[e];
              return (0, u.default)(this, this.fetchOptions);
            }
          }, {
            key: "sync",
            value: function (t, e) {
              if (t && "object" !== p(t)) throw new Error("Invalid parameters: params must be an object.");
              if (this._query = {}, t) for (var r in t) {
                var n = t[r];
                if (t.hasOwnProperty(r)) {
                  if (!("string" == typeof n || "number" == typeof n || "boolean" == typeof n || n instanceof RegExp || "object" === p(n) && null !== n)) throw new Error('Invalid parameter value for key "'.concat(r, '": must be a string, number, object, boolean, or RegExp.'));
                  this._query[r] = t[r];
                }
              }
              this.requestParams = {
                method: "POST",
                headers: o.mergeDeep({}, this.headers),
                url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.sync,
                body: {
                  _method: "GET",
                  query: this._query
                }
              };
              var i = o.mergeDeep(this.fetchOptions, e);
              return o.sendRequest(o.mergeDeep({}, this), i);
            }
          }, {
            key: "imageTransform",
            value: function (t, e) {
              if (t && "string" == typeof t && "object" === p(e) && void 0 === e.length) {
                var r = [];
                for (var n in e) {
                  var o = encodeURIComponent(n),
                    i = encodeURIComponent(e[n]);
                  r.push(o + "=" + i);
                }
                t += t.indexOf("?") <= -1 ? "?" + r.join("&") : "&" + r.join("&");
              }
              return t;
            }
          }], e && d(t.prototype, e), Object.defineProperty(t, "prototype", {
            writable: !1
          }), t;
          var t, e;
        }();
      },
      444: () => {},
      514: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0, e.default = function () {
          try {
            return window.localStorage;
          } catch (t) {
            return null;
          }
        }();
      },
      537: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0;
        var n = function (t, e) {
          if (t && t.__esModule) return t;
          if (null === t || "object" != i(t) && "function" != typeof t) return {
            default: t
          };
          var r = o(e);
          if (r && r.has(t)) return r.get(t);
          var n = {
              __proto__: null
            },
            a = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s in t) if ("default" !== s && {}.hasOwnProperty.call(t, s)) {
            var c = a ? Object.getOwnPropertyDescriptor(t, s) : null;
            c && (c.get || c.set) ? Object.defineProperty(n, s, c) : n[s] = t[s];
          }
          return n.default = t, r && r.set(t, n), n;
        }(r(925));
        function o(t) {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap(),
            r = new WeakMap();
          return (o = function (t) {
            return t ? r : e;
          })(t);
        }
        function i(t) {
          return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, i(t);
        }
        function a(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, s(n.key), n);
          }
        }
        function s(t) {
          var e = function (t) {
            if ("object" != i(t) || !t) return t;
            var e = t[Symbol.toPrimitive];
            if (void 0 !== e) {
              var r = e.call(t, "string");
              if ("object" != i(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(t);
          }(t);
          return "symbol" == i(e) ? e : e + "";
        }
        e.default = function () {
          return t = function t() {
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this._query = {}, this.only = n.transform("only"), this;
          }, (e = [{
            key: "toJSON",
            value: function () {
              return this.tojson = !0, this;
            }
          }, {
            key: "addParam",
            value: function (t, e) {
              if (t && "string" == typeof t && e && "string" == typeof e) return this._query[t] = e, this;
              this.fetchOptions.debug && this.fetchOptions.logHandler("error", "Kindly provide a valid parameters.");
            }
          }, {
            key: "includeFallback",
            value: function () {
              return this._query.include_fallback = !0, this;
            }
          }, {
            key: "includeMetadata",
            value: function () {
              return this._query.include_metadata = !0, this;
            }
          }, {
            key: "fetch",
            value: function (t) {
              if (this.asset_uid) {
                this.requestParams = {
                  method: "POST",
                  headers: n.mergeDeep({}, this.headers),
                  url: this.config.protocol + "://" + this.config.host + ":" + this.config.port + "/" + this.config.version + this.config.urls.assets + this.asset_uid,
                  body: {
                    _method: "GET",
                    query: this._query
                  }
                };
                var e = n.mergeDeep(this.fetchOptions, t);
                return n.sendRequest(n.mergeDeep({}, this), e);
              }
              t.debug && t.logHandler("error", "Kindly provide an asset uid. e.g. .Assets('asset_uid')");
            }
          }]) && a(t.prototype, e), Object.defineProperty(t, "prototype", {
            writable: !1
          }), t;
          var t, e;
        }();
      },
      641: (t, e, r) => {
        function n(t) {
          return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, n(t);
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0;
        var o = function (t, e) {
          if (t && t.__esModule) return t;
          if (null === t || "object" != n(t) && "function" != typeof t) return {
            default: t
          };
          var r = i(e);
          if (r && r.has(t)) return r.get(t);
          var o = {
              __proto__: null
            },
            a = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s in t) if ("default" !== s && {}.hasOwnProperty.call(t, s)) {
            var c = a ? Object.getOwnPropertyDescriptor(t, s) : null;
            c && (c.get || c.set) ? Object.defineProperty(o, s, c) : o[s] = t[s];
          }
          return o.default = t, r && r.set(t, o), o;
        }(r(94));
        function i(t) {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap(),
            r = new WeakMap();
          return (i = function (t) {
            return t ? r : e;
          })(t);
        }
        var a = {};
        function s(t, e) {
          !e && t && t.length && t.push("");
          var r,
            n = o.getKeys(),
            i = o.getStorage();
          if (t && t.length) {
            r = t.join(".");
            for (var a = 0, s = n.length; a < s; a++) n[a] && 0 === n[a].indexOf(r) && delete i[n[a]];
          } else for (var c = 0, u = n.length; c < u; c++) delete i[n[c]];
        }
        a.get = function (t, e) {
          try {
            e(null, o.get(t));
          } catch (t) {
            e(t);
          }
        }, a.set = function (t, e, r) {
          try {
            t && e && o.set(t, e), r();
          } catch (t) {
            r(t);
          }
        }, a.clearByContentType = function () {
          try {
            if (2 === arguments.length || 3 === arguments.length) {
              var t = Array.prototype.slice.call(arguments),
                e = t.splice(-1, 1).pop(),
                r = [];
              r.push.apply(r, t), s(r), e();
            }
          } catch (t) {
            callback(t);
          }
        }, a.clearByQuery = function (t, e) {
          try {
            for (var r = o.getKeys(), n = o.getStorage(), i = 0, a = r.length; i < a; i++) r[i] && ~r[i].indexOf(t) && delete n[r[i]];
            e();
          } catch (t) {
            e(t);
          }
        }, a.clearAll = function (t) {
          try {
            s(), t();
          } catch (e) {
            t(e);
          }
        }, e.default = a;
      },
      697: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.default = void 0, e.default = {
          EU: "eu",
          US: "us",
          AZURE_NA: "azure-na",
          AZURE_EU: "azure-eu",
          GCP_NA: "gcp-na",
          GCP_EU: "gcp-eu"
        };
      },
      925: (t, e, r) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e._type = function (t) {
          var e = u(t);
          return "object" === e && Array.isArray(t) && (e = "array"), e;
        }, e.generateHash = p, e.getHash = y, e.isBrowser = function () {
          return "undefined" != typeof window;
        }, e.merge = l, e.mergeDeep = function (t, e) {
          var r = this,
            n = function (t, e) {
              for (var o in e) "object" == r._type(e[o]) && r._type(t[o]) == r._type(e[o]) ? n(t[o], e[o]) : "array" == r._type(e[o]) && r._type(t[o]) == r._type(e[o]) ? t[o] = t[o].concat(e[o]) : t[o] = e[o];
            };
          return n(t, e), t;
        }, e.parseQueryFromParams = f, e.resultWrapper = d, e.sendRequest = function (t, e) {
          var r = t.environment_uid;
          r ? t._query.environment_uid = r : (t._query || (t._query = {}), t._query.environment = t.environment);
          var o = t,
            i = void 0 !== o.queryCachePolicy ? o.queryCachePolicy : o.cachePolicy,
            s = void 0 !== o.tojson && o.tojson,
            p = !!(o.entry_uid || o.singleEntry || o.asset_uid),
            v = y(f(o, p, s));
          if (t && t.requestParams && t.requestParams.body && t.requestParams.body.query) {
            var _ = JSON.parse(JSON.stringify(t.requestParams.body.query));
            "object" !== u(_) && (_ = JSON.parse(_)), delete t.requestParams.body.query, t.requestParams.body = l(t.requestParams.body, _), t.live_preview && !0 === t.live_preview.enable && t.live_preview.live_preview && "init" !== t.live_preview.live_preview && (t.requestParams.body = l(t.requestParams.body, {
              live_preview: t.live_preview.live_preview || "init"
            }), i = 2, t.requestParams.body.environment && delete t.requestParams.body.environment, t.requestParams.headers.access_token && delete t.requestParams.headers.access_token, delete t.requestParams.headers.authorization, delete t.requestParams.headers.preview_token, t.live_preview.preview_token ? (t.requestParams.headers.preview_token = t.live_preview.preview_token, t.requestParams.headers.live_preview = t.live_preview.live_preview) : t.live_preview.management_token && (t.requestParams.headers.authorization = t.live_preview.management_token));
          }
          var m = function (t, e) {
              return function (r, n) {
                try {
                  if (r) return e(r);
                  s || (n = d(n)), t(h(n));
                } catch (t) {
                  e(t);
                }
              };
            },
            b = function (r, a, c) {
              r && (0, n.default)(t, e).then(function (e) {
                try {
                  o.entry_uid = o.asset_uid = o.tojson = o.queryCachePolicy = void 0;
                  var r = {},
                    n = {};
                  if (t.singleEntry) {
                    if (t.singleEntry = !1, e.schema && (r.schema = e.schema), e.content_type && (r.content_type = e.content_type, delete r.schema), e.entries && e.entries.length) r.entry = e.entries[0];else {
                      if (!e.assets || !e.assets.length) return 2 === i && null !== o.provider ? void o.provider.get(v, function (t, e) {
                        if (t || !e || 0 === e.entries.length && 0 === e.assets.length) return c({
                          error_code: 141,
                          error_message: "The requested entry doesn't exist."
                        });
                        m(a, c)(t, e);
                      }) : c({
                        error_code: 141,
                        error_message: "The requested entry doesn't exist."
                      });
                      r.assets = e.assets[0];
                    }
                  } else e.items ? n = {
                    items: e.items,
                    pagination_token: e.pagination_token,
                    sync_token: e.sync_token,
                    total_count: e.total_count
                  } : r = e;
                  return -1 !== i && null !== o.provider ? (o.provider.set(v, r, function (t) {
                    try {
                      return t && c(t), s || (r = d(r)), a(h(r));
                    } catch (t) {
                      return c(t);
                    }
                  }), a(h(r))) : Object.keys(n).length ? a(n) : (s || (r = d(r)), a(h(r)));
                } catch (t) {
                  return c({
                    message: t.message
                  });
                }
              }.bind(o)).catch(function (t) {
                t ? c(t) : 2 === i && null !== o.provider && o.provider.get(v, m(a, c));
              });
            };
          switch (i) {
            case 1:
              return new Promise(function () {
                var t = c(a().mark(function t(e, r) {
                  return a().wrap(function (t) {
                    for (;;) switch (t.prev = t.next) {
                      case 0:
                        if (null === o.provider) {
                          t.next = 5;
                          break;
                        }
                        return t.next = 3, o.provider.get(v, function () {
                          var t = c(a().mark(function t(n, o) {
                            return a().wrap(function (t) {
                              for (;;) switch (t.prev = t.next) {
                                case 0:
                                  if (t.prev = 0, !n && o) {
                                    t.next = 5;
                                    break;
                                  }
                                  b(!0, e, r), t.next = 7;
                                  break;
                                case 5:
                                  return s || (o = d(o)), t.abrupt("return", e(h(o)));
                                case 7:
                                  t.next = 12;
                                  break;
                                case 9:
                                  return t.prev = 9, t.t0 = t.catch(0), t.abrupt("return", r(t.t0));
                                case 12:
                                case "end":
                                  return t.stop();
                              }
                            }, t, null, [[0, 9]]);
                          }));
                          return function (e, r) {
                            return t.apply(this, arguments);
                          };
                        }());
                      case 3:
                        t.next = 6;
                        break;
                      case 5:
                        b(!0, e, r);
                      case 6:
                      case "end":
                        return t.stop();
                    }
                  }, t);
                }));
                return function (e, r) {
                  return t.apply(this, arguments);
                };
              }());
            case 2:
            case 0:
            case void 0:
            case -1:
              return new Promise(function (t, e) {
                b(!0, t, e);
              });
          }
          if (3 === i) return new Promise(function (t, e) {
            null !== o.provider && o.provider.get(v, function (r, n) {
              try {
                r || !n ? e(r) : (s || (n = d(n)), t(h(n)));
              } catch (t) {
                e(t);
              }
            });
          }).then(function () {
            return new Promise(function (t, e) {
              b(!0, t, e);
            });
          }).catch(function (t) {
            return new Promise(function (t, e) {
              b(!0, t, e);
            });
          });
        }, e.spreadResult = h, e.transform = function (t) {
          return function () {
            switch (this._query[t] = this._query[t] || {}, arguments.length) {
              case 1:
                if (Array.isArray(arguments[0]) || "string" == typeof arguments[0]) {
                  var e = this._query[t].BASE || [];
                  return e = e.concat(arguments[0]), this._query[t].BASE = e, this;
                }
                console.error("Kindly provide valid parameters");
                break;
              case 2:
                if ("string" == typeof arguments[0] && (Array.isArray(arguments[1]) || "string" == typeof arguments[1])) {
                  var r = this._query[t][arguments[0]] || [];
                  return r = r.concat(arguments[1]), this._query[t][arguments[0]] = r, this;
                }
                console.error("Kindly provide valid parameters");
                break;
              default:
                console.error("Kindly provide valid parameters");
            }
          };
        };
        var n = i(r(185)),
          o = i(r(209));
        function i(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
        function a() {
          a = function () {
            return e;
          };
          var t,
            e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o = Object.defineProperty || function (t, e, r) {
              t[e] = r.value;
            },
            i = "function" == typeof Symbol ? Symbol : {},
            s = i.iterator || "@@iterator",
            c = i.asyncIterator || "@@asyncIterator",
            l = i.toStringTag || "@@toStringTag";
          function f(t, e, r) {
            return Object.defineProperty(t, e, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }), t[e];
          }
          try {
            f({}, "");
          } catch (t) {
            f = function (t, e, r) {
              return t[e] = r;
            };
          }
          function y(t, e, r, n) {
            var i = e && e.prototype instanceof b ? e : b,
              a = Object.create(i.prototype),
              s = new C(n || []);
            return o(a, "_invoke", {
              value: S(t, r, s)
            }), a;
          }
          function p(t, e, r) {
            try {
              return {
                type: "normal",
                arg: t.call(e, r)
              };
            } catch (t) {
              return {
                type: "throw",
                arg: t
              };
            }
          }
          e.wrap = y;
          var d = "suspendedStart",
            h = "suspendedYield",
            v = "executing",
            _ = "completed",
            m = {};
          function b() {}
          function g() {}
          function O() {}
          var w = {};
          f(w, s, function () {
            return this;
          });
          var P = Object.getPrototypeOf,
            j = P && P(P(L([])));
          j && j !== r && n.call(j, s) && (w = j);
          var q = O.prototype = b.prototype = Object.create(w);
          function E(t) {
            ["next", "throw", "return"].forEach(function (e) {
              f(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function k(t, e) {
            function r(o, i, a, s) {
              var c = p(t[o], t, i);
              if ("throw" !== c.type) {
                var l = c.arg,
                  f = l.value;
                return f && "object" == u(f) && n.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                  r("next", t, a, s);
                }, function (t) {
                  r("throw", t, a, s);
                }) : e.resolve(f).then(function (t) {
                  l.value = t, a(l);
                }, function (t) {
                  return r("throw", t, a, s);
                });
              }
              s(c.arg);
            }
            var i;
            o(this, "_invoke", {
              value: function (t, n) {
                function o() {
                  return new e(function (e, o) {
                    r(t, n, e, o);
                  });
                }
                return i = i ? i.then(o, o) : o();
              }
            });
          }
          function S(e, r, n) {
            var o = d;
            return function (i, a) {
              if (o === v) throw Error("Generator is already running");
              if (o === _) {
                if ("throw" === i) throw a;
                return {
                  value: t,
                  done: !0
                };
              }
              for (n.method = i, n.arg = a;;) {
                var s = n.delegate;
                if (s) {
                  var c = A(s, n);
                  if (c) {
                    if (c === m) continue;
                    return c;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                  if (o === d) throw o = _, n.arg;
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = v;
                var u = p(e, r, n);
                if ("normal" === u.type) {
                  if (o = n.done ? _ : h, u.arg === m) continue;
                  return {
                    value: u.arg,
                    done: n.done
                  };
                }
                "throw" === u.type && (o = _, n.method = "throw", n.arg = u.arg);
              }
            };
          }
          function A(e, r) {
            var n = r.method,
              o = e.iterator[n];
            if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, A(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
            var i = p(o, e.iterator, r.arg);
            if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
            var a = i.arg;
            return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
          }
          function T(t) {
            var e = {
              tryLoc: t[0]
            };
            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
          }
          function D(t) {
            var e = t.completion || {};
            e.type = "normal", delete e.arg, t.completion = e;
          }
          function C(t) {
            this.tryEntries = [{
              tryLoc: "root"
            }], t.forEach(T, this), this.reset(!0);
          }
          function L(e) {
            if (e || "" === e) {
              var r = e[s];
              if (r) return r.call(e);
              if ("function" == typeof e.next) return e;
              if (!isNaN(e.length)) {
                var o = -1,
                  i = function r() {
                    for (; ++o < e.length;) if (n.call(e, o)) return r.value = e[o], r.done = !1, r;
                    return r.value = t, r.done = !0, r;
                  };
                return i.next = i;
              }
            }
            throw new TypeError(u(e) + " is not iterable");
          }
          return g.prototype = O, o(q, "constructor", {
            value: O,
            configurable: !0
          }), o(O, "constructor", {
            value: g,
            configurable: !0
          }), g.displayName = f(O, l, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === g || "GeneratorFunction" === (e.displayName || e.name));
          }, e.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, O) : (t.__proto__ = O, f(t, l, "GeneratorFunction")), t.prototype = Object.create(q), t;
          }, e.awrap = function (t) {
            return {
              __await: t
            };
          }, E(k.prototype), f(k.prototype, c, function () {
            return this;
          }), e.AsyncIterator = k, e.async = function (t, r, n, o, i) {
            void 0 === i && (i = Promise);
            var a = new k(y(t, r, n, o), i);
            return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
          }, E(q), f(q, l, "Generator"), f(q, s, function () {
            return this;
          }), f(q, "toString", function () {
            return "[object Generator]";
          }), e.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return r.reverse(), function t() {
              for (; r.length;) {
                var n = r.pop();
                if (n in e) return t.value = n, t.done = !1, t;
              }
              return t.done = !0, t;
            };
          }, e.values = L, C.prototype = {
            constructor: C,
            reset: function (e) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(D), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var r = this;
              function o(n, o) {
                return s.type = "throw", s.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  s = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var c = n.call(a, "catchLoc"),
                    u = n.call(a, "finallyLoc");
                  if (c && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (c) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u) throw Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                  var i = o;
                  break;
                }
              }
              i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
              var a = i ? i.completion : {};
              return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), m;
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), D(r), m;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var o = n.arg;
                    D(r);
                  }
                  return o;
                }
              }
              throw Error("illegal catch attempt");
            },
            delegateYield: function (e, r, n) {
              return this.delegate = {
                iterator: L(e),
                resultName: r,
                nextLoc: n
              }, "next" === this.method && (this.arg = t), m;
            }
          }, e;
        }
        function s(t, e, r, n, o, i, a) {
          try {
            var s = t[i](a),
              c = s.value;
          } catch (t) {
            return void r(t);
          }
          s.done ? e(c) : Promise.resolve(c).then(n, o);
        }
        function c(t) {
          return function () {
            var e = this,
              r = arguments;
            return new Promise(function (n, o) {
              var i = t.apply(e, r);
              function a(t) {
                s(i, n, o, a, c, "next", t);
              }
              function c(t) {
                s(i, n, o, a, c, "throw", t);
              }
              a(void 0);
            });
          };
        }
        function u(t) {
          return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, u(t);
        }
        function l(t, e) {
          if (t && e) for (var r in e) t[r] = e[r];
          return t;
        }
        function f(t, e, r) {
          if (t && t.requestParams) {
            var n = l({}, t.requestParams.body && t.requestParams.body.query || {});
            return n.environment_uid && (delete n.environment_uid, n.environment = t.environment), n.environment = t.environment, {
              content_type_uid: t.content_type_uid,
              locale: n.locale || "en-us",
              query: n,
              entry_uid: t.entry_uid,
              asset_uid: t.asset_uid,
              single: e || "false",
              toJSON: r || "false",
              api_key: t.requestParams.headers ? t.requestParams.headers.api_key : ""
            };
          }
        }
        function y(t) {
          try {
            var e = p(JSON.stringify(t)),
              r = [];
            return r.push(t.content_type_uid), r.push(t.locale), t.entry_uid && r.push(t.entry_uid), t.asset_uid && r.push(t.asset_uid), r.push(e), r.join(".");
          } catch (t) {}
        }
        function p(t) {
          var e,
            r,
            n = 0;
          if (0 === t.length) return n;
          for (e = 0, r = t.length; e < r; e++) n = (n << 5) - n + t.charCodeAt(e), n |= 0;
          return n < -1 ? -1 * n : n;
        }
        function d(t) {
          if (t && void 0 !== t.entries) {
            if (t.entries && t.entries.length) for (var e = 0, r = t.entries.length; e < r; e++) t.entries[e] = (0, o.default)(t.entries[e]);else t.entries = [];
          } else if (t && t.assets && void 0 !== t.assets) {
            if (t.assets && t.assets.length) for (var n = 0, i = t.assets.length; n < i; n++) t.assets[n] = (0, o.default)(t.assets[n]);else t.assets = [];
          } else t && void 0 !== t.entry ? t.entry = (0, o.default)(t.entry) : t && void 0 !== t.asset ? t.asset = (0, o.default)(t.asset) : t && void 0 !== t.items && (t.items = (0, o.default)(t.items).toJSON());
          return t;
        }
        function h(t) {
          var e = [];
          return t && Object.keys(t).length && (void 0 !== t.entries && (e.push(t.entries), t.content_type && (e.schema = t.content_type)), void 0 !== t.assets && e.push(t.assets), void 0 === t.content_type && void 0 === t.schema || e.push(t.content_type || t.schema), void 0 !== t.count && e.push(t.count), void 0 !== t.entry && (e = t.entry, t.schema && (e.schema = t.schema), t.content_type && (e.content_type = t.content_type)), void 0 !== t.asset && (e = t.asset), void 0 !== t.items && e.push(t)), e;
        }
        Promise.prototype.spread || (Promise.prototype.spread = function (t, e) {
          return e = e || function (t) {}, this.then(function (e) {
            return t.apply(t, e);
          }).catch(function (t) {
            e(t);
          });
        });
      },
      949: (t, e, r) => {
        var n = a(r(348)),
          o = a(r(285)),
          i = a(r(697));
        function a(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
        function s(t) {
          return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, s(t);
        }
        function c(t, e) {
          var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
          if (!r) {
            if (Array.isArray(t) || (r = function (t, e) {
              if (t) {
                if ("string" == typeof t) return u(t, e);
                var r = {}.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? u(t, e) : void 0;
              }
            }(t)) || e && t && "number" == typeof t.length) {
              r && (t = r);
              var n = 0,
                o = function () {};
              return {
                s: o,
                n: function () {
                  return n >= t.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: t[n++]
                  };
                },
                e: function (t) {
                  throw t;
                },
                f: o
              };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          var i,
            a = !0,
            s = !1;
          return {
            s: function () {
              r = r.call(t);
            },
            n: function () {
              var t = r.next();
              return a = t.done, t;
            },
            e: function (t) {
              s = !0, i = t;
            },
            f: function () {
              try {
                a || null == r.return || r.return();
              } finally {
                if (s) throw i;
              }
            }
          };
        }
        function u(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var r = 0, n = Array(e); r < e; r++) n[r] = t[r];
          return n;
        }
        function l(t, e) {
          var r = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e && (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), r.push.apply(r, n);
          }
          return r;
        }
        function f(t, e, r) {
          return (e = h(e)) in t ? Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = r, t;
        }
        function y(t, e) {
          return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
            return t.__proto__ = e, t;
          }, y(t, e);
        }
        function p() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (p = function () {
            return !!t;
          })();
        }
        function d(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, h(n.key), n);
          }
        }
        function h(t) {
          var e = function (t) {
            if ("object" != s(t) || !t) return t;
            var e = t[Symbol.toPrimitive];
            if (void 0 !== e) {
              var r = e.call(t, "string");
              if ("object" != s(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(t);
          }(t);
          return "symbol" == s(e) ? e : e + "";
        }
        var v = function () {
          return t = function t() {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.CachePolicy = o.default.policies, this.Region = i.default, this.Utils = r(215);
          }, e = [{
            key: "Stack",
            value: function () {
              for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
              return function (t, e, r) {
                if (p()) return Reflect.construct.apply(null, arguments);
                var n = [null];
                n.push.apply(n, e);
                var o = new (t.bind.apply(t, n))();
                return r && y(o, r.prototype), o;
              }(n.default, e);
            }
          }, {
            key: "updateAssetURL",
            value: function (t) {
              if (null == t._embedded_items) throw new Error("_embedded_items not present in entry. Call includeEmbeddedItems() before fetching entry.");
              var e = function (e) {
                var r = t._embedded_items[e];
                Array.isArray(r) && r.forEach(function (r) {
                  if ("sys_assets" == r._content_type_uid && r.filename) {
                    var n,
                      o,
                      i = function (t) {
                        for (var e = 0; e < t.length; e++) if (t[e].children && t[e].children.length && i(t[e].children), t[e].attrs && t[e].attrs["asset-uid"] === r.uid) return void (n = t[e].attrs);
                      },
                      a = function (t) {
                        for (var e = 1; e < arguments.length; e++) {
                          var r = null != arguments[e] ? arguments[e] : {};
                          e % 2 ? l(Object(r), !0).forEach(function (e) {
                            f(t, e, r[e]);
                          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function (e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                          });
                        }
                        return t;
                      }({}, t),
                      u = e.split("."),
                      y = new Set(["__proto__", "constructor", "prototype"]),
                      p = c(u);
                    try {
                      for (p.s(); !(o = p.n()).done;) {
                        var d = o.value;
                        if (!y.has(d)) if (a && "object" === s(a) && null !== a && Object.prototype.hasOwnProperty.call(a, d)) {
                          var h = a[d];
                          "object" === s(h) && null !== h && (a = h);
                        } else if (Array.isArray(a)) {
                          var v,
                            _ = c(a);
                          try {
                            for (_.s(); !(v = _.n()).done;) {
                              var m = v.value;
                              m && "object" === s(m) && Object.prototype.hasOwnProperty.call(m, d) && (a = m[d]);
                            }
                          } catch (t) {
                            _.e(t);
                          } finally {
                            _.f();
                          }
                        }
                      }
                    } catch (t) {
                      p.e(t);
                    } finally {
                      p.f();
                    }
                    a.children && i(a.children), n && (n.href = r.url);
                  }
                });
              };
              for (var r in t._embedded_items) e(r);
            }
          }], e && d(t.prototype, e), Object.defineProperty(t, "prototype", {
            writable: !1
          }), t;
          var t, e;
        }();
        t.exports = new v();
      }
    },
    e = {};
  return function r(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var i = e[n] = {
      exports: {}
    };
    return t[n](i, i.exports, r), i.exports;
  }(949);
})());